export enum GroupUsageKind {
  AssignmentRule = 'assignmentRules',
  Document = 'documents',
  ScheduledAudit = 'scheduledAudits',
  AdHocAudit = 'adHocAudits',
}

export const GROUP_USAGE_KINDS = [
  GroupUsageKind.Document,
  GroupUsageKind.ScheduledAudit,
  GroupUsageKind.AdHocAudit,
] as const;

const GROUP_USAGE_NOUNS: Record<GroupUsageKind, [singular: string, plural: string]> = {
  [GroupUsageKind.AssignmentRule]: ['assignment rule', 'assignment rules'],
  [GroupUsageKind.Document]: ['document', 'documents'],
  [GroupUsageKind.ScheduledAudit]: ['scheduled audit', 'scheduled audits'],
  [GroupUsageKind.AdHocAudit]: ['ad-hoc audit', 'ad-hoc audits'],
};

export const usageCountLabel = (kind: GroupUsageKind, count: number): string => {
  const [singular, plural] = GROUP_USAGE_NOUNS[kind];
  return `${count} ${count === 1 ? singular : plural}`;
};
